import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import OTPVerification from './OTPVerification';
import logger from '../utils/logger';

const EmailVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { verifyEmail, resendVerificationOTP, loading } = useAuth();
  
  const email = location.state?.email || '';
  const message = location.state?.message || 'Please check your email for the verification code.';
  
  const [error, setError] = useState('');
  logger.log(email,'email');
  
  // Redirect if no email provided
  React.useEffect(() => {
    if (!email) {
      navigate('/register');
    }
  }, [email, navigate]);

  const handleVerify = async (otpCode) => {
    setError('');
    
    try {
      const result = await verifyEmail(email, otpCode);
      
      if (result.success) {
        // ✅ Check if consultant needs approval
        if (result.requires_approval && result.consultant_status) {
          logger.log('⚠️ Consultant verified but needs approval:', result.consultant_status);
          navigate('/consultant-status', {
            state: {
              consultant_status: result.consultant_status,
              email: result.email || email
            },
            replace: true
          });
          return;
        }
        
        // Now the user should be authenticated in AuthContext
        // The verifyEmail function should set isAuthenticated = true
        
        if (result.auto_login) {
          navigate('/', { 
            state: { 
              message: 'Email verified successfully! Welcome to Rely Ability.',
              messageType: 'success'
            },
            replace: true
          });
        } else {
          navigate('/login', { 
            state: { 
              message: 'Email verified successfully! Please log in.',
              messageType: 'success'
            },
            replace: true
          });
        }
      } else {
        throw new Error(result.error || 'Verification failed');
      }
    } catch (err) {
      logger.error('Verification error:', err);
      setError(err.message || 'Verification failed. Please try again.');
      throw err;
    }
  };

  const handleResend = async () => {
    setError('');
    
    try {
      await resendVerificationOTP(email);
    } catch (err) {
      logger.error('Resend error:', err);
      setError(err.message || 'Failed to resend verification code');
      throw err; // Re-throw to let OTPVerification handle it
    }
  };

  if (!email) {
    return null; // Will redirect to register
  }

  return (
    <div>
      {/* Show success message if provided */}
      {message && (
        <div className="fixed top-4 right-4 z-50 bg-green-100 dark:bg-green-900/30 border border-green-400 dark:border-green-700 text-green-700 dark:text-green-300 px-4 py-3 rounded-lg shadow-lg max-w-md">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-green-400 dark:text-green-300 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium">{message}</p>
            </div>
          </div>
        </div>
      )}

      <OTPVerification
        email={email}
        type="verification"
        onVerify={handleVerify}
        onResend={handleResend}
        loading={loading}
      />
    </div>
  );
};

export default EmailVerification;
